import * as types from '../constants';

export function highlightLeftMenu(key) {
  return {
    type: types.HIGHLIGHT_LEFT_MENU,
    key: key,
  };
}
